import React from "react";
import StudentNavBar from "../Nav/StudentNavBar";
import styled from "styled-components";

export default function StudentRightSide({data}) {

  return (
    <RightElements>
      <StudentNavBar navItems={data}/>
    </RightElements>
  );
}

const RightElements = styled.div`
  width: fit-content;
  height: 100%;
  display: inline-block;
  padding: 15px 15px 0 0;
`;
